import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import AnalyticsManager from './modules/analytics'

// Preserve existing global styles for parity during incremental migration
import '../styles.css'

const container = document.getElementById('root')
if (container) {
  // Initialize analytics early in React app lifecycle
  if (typeof window !== 'undefined') {
    // @ts-ignore - window typings extended in global.d.ts
    window.analytics = new AnalyticsManager()
  }
  const root = createRoot(container)
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  )
}
else {
  console.warn('React root element not found: #root')
}
